import { CSSProperties } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const TreeNodeExpansionWidth = '1.5rem';

export type ChildNodesProps = Readonly<{ $isExpanded: boolean }>;

export const ChildNodes = styled.div<ChildNodesProps>`
    display: ${({ $isExpanded }) => ($isExpanded ? 'block' : 'none')};
    margin-left: 1rem;
`;

export const NodeContent = styled.div`
    display: flex;
    align-items: center;
`;

export const NodeExpansion = styled.div`
    justify-content: center;
`;

export const ExpansionSpacer = styled.div`
    width: ${TreeNodeExpansionWidth};
`;

export const ExpansionButton = styled.button`
    border: none;
    background: none;
    width: ${TreeNodeExpansionWidth};
    cursor: pointer;
    font-size: 14px;
    color: ${tokens.text.primary};
    margin: 0;
    padding: 0;
`;

export const SpinnerIcon = styled.div`
    width: ${TreeNodeExpansionWidth};
    font-size: 12px;
`;

export const SelectionInputWrapper = styled.label`
    padding-left: 0.5rem;
    pointer-events: none;
    display: flex;
    justify-content: center;
`;

export type NodeLabelProps = Readonly<{
    $isSelectable: boolean;
    $isDisabled: boolean;
}>;

const getNodeLabelCursor = ({
    $isSelectable,
    $isDisabled,
}: NodeLabelProps): CSSProperties['cursor'] => {
    if (!$isSelectable) {
        return 'inherit';
    }
    return $isDisabled ? 'not-allowed' : 'pointer';
};

export const NodeLabel = styled.label<NodeLabelProps>`
    flex: 1;
    min-width: 0;
    background: none;
    text-align: left;
    display: flex;
    align-items: center;
    cursor: ${getNodeLabelCursor};
`;

export const RenderedNodeLabel = styled.div`
    min-width: 0;
    flex: 1;
    padding: 0.1rem 0.25rem;
`;

export const DragPreview = styled.div`
    box-shadow: ${tokens.elevation['200']};
    position: fixed;
    pointer-events: none;
`;

export const DragDropContainer = styled.div`
    margin: 1px;
    box-sizing: border-box;
`;
